var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#346FCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.34 10.5222L11.8777 11.533C12.1836 12.1084 12.2485 12.7818 12.058 13.405C11.8674 14.0282 11.4372 14.5502 10.8619 14.8563L10.7921 14.8934C10.5072 15.0449 10.1952 15.1389 9.87392 15.1698C9.55267 15.2008 9.22846 15.1682 8.91982 15.0739C8.61117 14.9795 8.32413 14.8253 8.07508 14.6201C7.82603 14.4148 7.61985 14.1625 7.46831 13.8775L5.65538 10.4676C5.36062 9.91334 5.28917 9.26725 5.45569 8.66194C5.62221 8.05663 6.01407 7.538 6.55088 7.21246L6.01313 6.20164C5.70728 5.62615 5.64255 4.95275 5.83316 4.32953C6.02377 3.70632 6.45413 3.18434 7.02956 2.87839L7.09931 2.84127C7.67473 2.53538 8.34809 2.47056 8.97129 2.66107C9.5945 2.85158 10.1165 3.28181 10.4226 3.85714L12.2355 7.26702C12.5303 7.82125 12.6018 8.4673 12.4354 9.0726C12.269 9.6779 11.8767 10.1966 11.34 10.5222ZM11.34 10.5222L10.0648 8.12314C9.75877 7.54781 9.23675 7.11758 8.61354 6.92707C7.99034 6.73656 7.31698 6.80138 6.74156 7.10727L6.67181 7.14383C6.63075 7.16633 6.59025 7.18883 6.55088 7.21246L7.82662 9.61152C8.13267 10.1869 8.65469 10.6171 9.2779 10.8076C9.9011 10.9981 10.5745 10.9333 11.1499 10.6274L11.2196 10.5908C11.2607 10.5683 11.3006 10.5458 11.34 10.5222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.33b52cfd9c3be87777798d9165a9857e.svg";
export { ForwardRef as ReactComponent };